export enum ELocalStorage {
    USER_DATA = 'userData',
}
